import { useEffect, useState } from "react";
import { Target, MousePointerClick, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function TopHunters({ refreshKey }) {
  const [hunters, setHunters] = useState([]);

  const load = async () => {
    try {
      const { data } = await api.get("/hunters/leaderboard?limit=5");
      setHunters(data);
    } catch {}
  };

  useEffect(() => {
    load();
    const iv = setInterval(load, 6000);
    return () => clearInterval(iv);
  }, [refreshKey]);

  return (
    <aside
      data-testid="top-hunters-panel"
      className="rounded-2xl border border-neon-red/20 bg-void-card p-5"
    >
      <div className="flex items-center gap-2 mb-4">
        <div className="w-8 h-8 rounded-lg bg-neon-red/15 border border-neon-red/40 flex items-center justify-center">
          <Target className="w-4 h-4 text-neon-red" />
        </div>
        <div>
          <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-neon-red">
            HUNTER LEADERBOARD
          </div>
          <div className="font-heading font-bold text-base leading-tight">
            Top Hunters Today
          </div>
        </div>
      </div>

      {hunters.length === 0 ? (
        <div
          data-testid="hunters-empty"
          className="text-xs font-mono text-muted-foreground py-4 text-center"
        >
          Aún nadie ha registrado clicks hoy. ¡Sé el primero!
        </div>
      ) : (
        <ul className="space-y-2">
          {hunters.map((h, i) => (
            <li
              key={h.hunter_id}
              data-testid={`top-hunter-${i + 1}`}
              className="flex items-center gap-3 p-2.5 rounded-lg bg-black/50 border border-white/5"
            >
              <div
                className={`w-7 h-7 rounded-md flex items-center justify-center font-mono font-bold text-sm flex-shrink-0 ${
                  i === 0
                    ? "bg-neon-red text-white"
                    : "bg-white/5 text-neon-red border border-neon-red/20"
                }`}
              >
                {i + 1}
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-mono truncate">{h.email_masked}</div>
                <div className="flex items-center gap-2 text-[10px] font-mono text-muted-foreground mt-0.5">
                  <span className="inline-flex items-center gap-1 text-[#25D366]">
                    <MessageCircle className="w-2.5 h-2.5" /> {h.viral_points ?? 0}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <MousePointerClick className="w-2.5 h-2.5" /> {h.unique_clicks ?? 0}
                  </span>
                </div>
              </div>
              <div className="text-right">
                <div className="font-mono text-base font-bold text-neon-red leading-none">
                  {h.viral_points ?? 0}
                </div>
                <div className="text-[9px] font-mono text-muted-foreground uppercase">
                  viral pts
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
      <p className="text-[10px] font-mono text-muted-foreground mt-4 leading-relaxed">
        Winner = mayor viral_points (clicks vía WhatsApp share). Tiebreak: unique clicks.
      </p>
    </aside>
  );
}
